import { __awaiter, __generator } from "tslib";
export var createSelectDriver = function (wrapper, className, portalTargetWrapper) {
    var classNames = className ? ".new-select." + className : '.new-select';
    var select = wrapper.$(classNames);
    var selectMenu = portalTargetWrapper ? portalTargetWrapper.$('.select-v3__menu-portal') : select;
    var mouseDownOnElement = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, e.click()];
        });
    }); };
    var focusInput = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, select.$('.select-v3__value-container').click()];
        });
    }); };
    var focusSelect = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, select.$('.select-v3__control').click()];
        });
    }); };
    var optionAtIndex = function (index) { return selectMenu.$$('.select-v3__option').get(index); };
    var optionWithText = function (text) { return wrapper
        .$$('.select-v3__option')
        .filter(function (elemDriver) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, elemDriver.text()];
            case 1: return [2 /*return*/, (_a.sent()).includes(text)];
        }
    }); }); })
        .get(0); };
    return {
        openSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, focusInput()];
        }); }); },
        openNonSearchSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, focusSelect()];
        }); }); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        option = optionAtIndex(index);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectByText: function (text) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                option = optionWithText(text);
                return [2 /*return*/, mouseDownOnElement(option)];
            });
        }); },
        selectAtIndexNoSearch: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selector = '.select-v3__option';
                        return [4 /*yield*/, selectMenu.$$(selector).get(index).click()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        getSelectionTitlesNoSearch: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selector = '.select-v3__option';
                        return [4 /*yield*/, focusSelect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, selectMenu.$$(selector).text()];
                }
            });
        }); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = '.select-v3__option';
                        return [2 /*return*/, selectMenu.$$(selector)
                                .map(function (e) { return e.text(); })];
                }
            });
        }); },
        selectByOptionClassName: function (cn) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = '.select-v3__option';
                        option = selectMenu.$(selector + "." + cn);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectOptionsBySelector: function (sel) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = '.select-v3__option';
                        option = selectMenu.$(selector + " " + sel);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        getSelectedValue: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = 'select-v3__single-value';
                return [2 /*return*/, select.hasClass(selector) ? select.$("." + selector).text() : ''];
            });
        }); },
        getPlaceholder: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = '.select-v3__placeholder';
                return [2 /*return*/, select.$(selector).text()];
            });
        }); },
        enterText: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = '.select-v3__input input';
                return [2 /*return*/, select.$(selector).enterValue(val)];
            });
        }); },
        getInputText: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = '.select-v3__input';
                return [2 /*return*/, select.$(selector).text()];
            });
        }); },
        isDisabled: function () {
            var disabledSelector = 'select-v3--is-disabled';
            return select.hasClass(disabledSelector);
        },
        isOptionDisabledByIdx: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var cn, disabledClassname;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        cn = '.select-v3__option';
                        disabledClassname = 'select-v3__option--is-disabled';
                        return [2 /*return*/, selectMenu.$$(cn).get(idx).hasClass(disabledClassname)];
                }
            });
        }); },
        isSmall: function () { return select.hasClass('small'); },
        isMenuOpen: function () { return select.$('.select-v3__menu').exists(); },
        noResultsText: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = '.select-v3__menu';
                return [2 /*return*/, selectMenu.$(selector).text()];
            });
        }); },
        menuFooter: selectMenu.$('.select-menu-footer'),
        base: select
    };
};
//# sourceMappingURL=driver.js.map